import api from '../services/api'
import Helper from './helper'

class StockHistoryService {
  get(p, s, pid) {
    if (pid) {
      return api.get(`/psh?${Helper.getPageQuery(p, s)}&pid=${pid}`)
    }
    return api.get(`/psh?${Helper.getPageQuery(p, s)}`)
  }
}

export default new StockHistoryService()
